import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=3785c176&scoped=true&"
import script from "./SidebarMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=3785c176&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3785c176",
  null
  
)

component.options.__file = "SidebarMenu.vue"
export default component.exports